import { Action } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import * as Objects from '@core/objects';
import * as CFormsSearch from '@core/custom-forms/models/field-search.model';

export enum CustomFormsActionType {
    LoadFilters = "[CustomForms] Obtain filters",

    LoadFilterLabels = "[CustomForms] GET - Obtain labels filters - GET",
    LoadFilterLabelsSuccess = "[CustomForms] GET - Obtain labels filter SUCCESS",
    LoadFilterLabelsError = "[CustomForms] GET - Obtain labels filter ERROR",

    LoadFilterStatus = "[CustomForms] GET - Obtain status filters - GET",
    LoadFilterStatusSuccess = "[CustomForms] GET - Obtain status filter SUCCESS",
    LoadFilterStatusError = "[CustomForms] GET - Obtain status filter ERROR",

    LoadCategories = "[CustomForms] GET - Find labels categories",
    LoadCategoriesSuccess = "[CustomForms] GET - Find labels categories SUCCESS",
    LoadCategoriesError = "[CustomForms] GET - Find labels categories ERROR",

    LoadUsers = "[CustomForms] GET - Find users",
    LoadUsersSuccess = "[CustomForms] GET - Find users SUCCESS",
    LoadUsersError = "[CustomForms] GET - Find users ERROR",

    InitializeSearch = "[CustomForms] Initialize artworks search for a field",
    SearchArtworks = "[CustomForms] GET - Find field artworks by search",
    SearchArtworksSuccess = "[CustomForms] GET - Find field artworks by search SUCCESS",
    SearchArtworksError = "[CustomForms] GET - Find field artworks by search ERROR",

    ApplySearchFilter = "[CustomForms] apply filters to field search",
    RemoveSearchFilter = "[CustomForms] Remove filter on field search",
    UpdateQueryParams = "[CustomForms] update field search query params",
    SetQueryParams = "[CustomForms] set field search query params",
    SetSearchTerm = "[CustomForms] set field search term",

    CleanArtworks = "[CustomForms] Clear field artworks search results",
}

// Load Available Events
export class LoadFilters implements Action {
    readonly type = CustomFormsActionType.LoadFilters;
    constructor() {}
}

export class LoadFilterLabels implements Action {
    readonly type = CustomFormsActionType.LoadFilterLabels;
    constructor() {}
}

export class LoadFilterLabelsSuccess implements Action {
    readonly type = CustomFormsActionType.LoadFilterLabelsSuccess;
    constructor(public labels: Array<Objects.Label>) {}
}

export class LoadFilterLabelsError implements Action {
    readonly type = CustomFormsActionType.LoadFilterLabelsError;
    constructor(public error: HttpErrorResponse) {}
}

export class LoadFilterStatus implements Action {
    readonly type = CustomFormsActionType.LoadFilterStatus;
    constructor() {}
}

export class LoadFilterStatusSuccess implements Action {
    readonly type = CustomFormsActionType.LoadFilterStatusSuccess;
    constructor(public status: Array<Objects.Status>) {}
}

export class LoadFilterStatusError implements Action {
    readonly type = CustomFormsActionType.LoadFilterStatusError;
    constructor(public error: HttpErrorResponse) {}
}

export class LoadCategories implements Action {
    readonly type = CustomFormsActionType.LoadCategories;
    constructor() {}
}

export class LoadCategoriesSuccess implements Action {
    readonly type = CustomFormsActionType.LoadCategoriesSuccess;
    constructor(public categories: Array<Objects.LabelsGroup>) {}
}

export class LoadCategoriesError implements Action {
    readonly type = CustomFormsActionType.LoadCategoriesError;
    constructor(public error: HttpErrorResponse) {}
}

export class LoadUsers implements Action {
    readonly type = CustomFormsActionType.LoadUsers;
    constructor() {}
}

export class LoadUsersSuccess implements Action {
    readonly type = CustomFormsActionType.LoadUsersSuccess;
    constructor(public users: Array<Objects.User>) {}
}

export class LoadUsersError implements Action {
    readonly type = CustomFormsActionType.LoadUsersError;
    constructor(public error: HttpErrorResponse) {}
}

export class SearchArtworks implements Action {
    readonly type = CustomFormsActionType.SearchArtworks;
    constructor(public uuid: string) {}
}

export class SearchArtworksSuccess implements Action {
    readonly type = CustomFormsActionType.SearchArtworksSuccess;
    constructor(public uuid: string, public versions: Array<Objects.Version>) {}
}

export class SearchArtworksError implements Action {
    readonly type = CustomFormsActionType.SearchArtworksError;
    constructor(public uuid: string, public error: HttpErrorResponse) {}
}

export class InitializeSearch implements Action {
    readonly type = CustomFormsActionType.InitializeSearch;
    constructor(public uuid: string) {}
}

export class ApplySearchFilter implements Action {
    readonly type = CustomFormsActionType.ApplySearchFilter;
    constructor(public uuid: string, public filters: CFormsSearch.SearchAppliedFilter[]) {}
}

export class RemoveSearchFilter implements Action {
    readonly type = CustomFormsActionType.RemoveSearchFilter;
    constructor(public uuid: string, public filter: CFormsSearch.SearchAppliedFilter) {}
}

export class SetSearchTerm implements Action {
    readonly type = CustomFormsActionType.SetSearchTerm;
    constructor(public uuid: string, public term: string) {}
}

export class UpdateQueryParams implements Action {
    readonly type = CustomFormsActionType.UpdateQueryParams;
    constructor(public uuid: string) {}
}

export class SetQueryParams implements Action {
    readonly type = CustomFormsActionType.SetQueryParams;
    constructor(public uuid: string, public params: CFormsSearch.SearchQueryParams) {}
}

export class CleanArtworks implements Action {
    readonly type = CustomFormsActionType.CleanArtworks;
    constructor(public uuid: string) {}
}


export type CustomFormsActions = LoadFilters |
                                LoadFilterLabels |
                                LoadFilterLabelsSuccess |
                                LoadFilterLabelsError |
                                
                                LoadFilterStatus |
                                LoadFilterStatusSuccess |
                                LoadFilterStatusError |

                                LoadCategories |
                                LoadCategoriesSuccess |
                                LoadCategoriesError |
                                
                                LoadUsers |
                                LoadUsersSuccess |
                                LoadUsersError |

                                InitializeSearch |
                                
                                SearchArtworks |
                                SearchArtworksSuccess|
                                SearchArtworksError |

                                ApplySearchFilter |
                                RemoveSearchFilter |
                                SetSearchTerm |
                                UpdateQueryParams |
                                SetQueryParams |
                                
                                CleanArtworks;